import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-upload-attendance',
  templateUrl: './upload-attendance.component.html',
  styleUrls: ['./upload-attendance.component.scss']
})
export class UploadAttendanceComponent implements OnInit {
  @ViewChild('fileInput') fileInput:any;  
  contactList=[] as any;
  constructor(private service:SharedService) { }

  ngOnInit(): void 
  {
    this.service.GetExcelData().subscribe(data=>
    {
      this.contactList=data;
      console.log(this.contactList)
      console.log(this.contactList)
      for(let i=0;i<this.contactList.length;i++)
      {
        console.log(this.contactList[i]['FkEmpId'])
        console.log(this.contactList[i]['DateTime'])
      }
    });
  }


  uploadFile()
  {
    let file = new FormData();  
    file.append('file', this.fileInput.nativeElement.files[0])  
    // console.log(file)
    this.service.UploadExcel(file).subscribe(data  => 
      {
        console.log("POST Request is successful ", data);
      }
    );   
  }
}
